<span id="mathContent" [innerHTML]="mathFormula"></span>
<ng-content></ng-content>
